import { useTranslation } from 'next-i18next';
import styles from './index.module.less';
import { CloseOutlined } from '@ant-design/icons';
import { Affix } from 'antd';
import { useConfigProvider } from '@/context/ConfigProvider';
import Link from 'next/link';

const ArticleBottomAlert = () => {
  const { t } = useTranslation('common');
  const { onShowArticleBottomAlert, isShowArticleBottomAlert } = useConfigProvider();

  return (
    <>
      {isShowArticleBottomAlert && (
        <Affix offsetBottom={0} style={{ zIndex: '9999' }}>
          <div className={styles.content}>
            <CloseOutlined
              className={styles.closeIcon}
              onClick={(e) => {
                e?.stopPropagation();
                onShowArticleBottomAlert(false);
              }}
            />
            <Link href={'/'}>
              <div className={styles.contentInfo}>
                <div>{t('Get trendy hairstyles and Keep Shining!')}</div>
                <span>{t('Start Styling >')}</span>
              </div>
            </Link>
          </div>
        </Affix>
      )}
    </>
  );
};

export default ArticleBottomAlert;
